import React, { /* useEffect, */ useState } from 'react';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
/* import Input from 'components/common/Input'; */
import SoftBadge from 'components/common/SoftBadge';
import { currency /* , noCurrency */ } from 'helpers/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from 'react-bootstrap';
import dayjs from 'dayjs';

const Dues = ({ num, fechaPago, /* cuotaFija, */ res }) => {
 const [open, setOpen] = useState(false);
 return (
  <>
   <Flex justifyContent="around" alignItems="center" onClick={() => setOpen(!open)}>
    <SoftBadge pill bg="primary">
     {num}
    </SoftBadge>
    <div className="position-relative" style={{ maxWidth: '150px' }}>
     <FontAwesomeIcon icon="calendar-alt" className="position-absolute top-50 start-0 fs--2 translate-middle-y" />
     <span className="ms-3">{fechaPago}</span>
    </div>
    <div className="position-relative">
     <FontAwesomeIcon icon="dollar-sign" className="position-absolute top-50 start-0 fs--1 translate-middle-y" />
     <span className="ms-3">{currency((res.saldoCuota + res.deuda - res.deudaPaga).toString(), false, true, true)}</span>
     {res?.saldoCuota < 1 && (
      <FontAwesomeIcon icon="check" className="text-success position-absolute top-0 start-100 fs--1 translate-middle-y" />
     )}
     {dayjs(res.fechaLimitePago).isBefore(dayjs()) && (
      <FontAwesomeIcon icon="ban" className="text-danger position-absolute top-0 start-100 fs--1 translate-middle-y" />
     )}
    </div>
   </Flex>
   <div className="position-relative">
    <Collapse in={open}>
     <div className="position-absolute bg-100 top-100 start-50 fs--1 translate-middle-x z-index-1 p-3">
      <pre>
       <code className="fs--2">{JSON.stringify(res, null, 2)}</code>
      </pre>
     </div>
    </Collapse>
   </div>
  </>
 );
};

Dues.propTypes = {
 num: PropTypes.number.isRequired,
 fechaPago: PropTypes.string,
 cuotaFija: PropTypes.number,
 res: PropTypes.object
};

export default Dues;
